import styles from './DialogLegacyContent.module.scss';
import React, { useEffect, useRef } from 'react';
export function DialogLegacyContent({ onMount }) {
    const containerRef = useRef(null);
    useEffect(()=>{
        if (containerRef.current == null) return;
        onMount(containerRef.current);
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: styles.legacyContent,
        "data-testid": "dialog-legacy-content"
    });
}
